import { callAPI } from '../../shared/network';

export async function getEmployeeWorkShift (employeeId){
  
   const data = await callAPI(
                       null, 
                        'SelfManagement/getEmployeeWorkShift?employeeId='+ employeeId, 'get');
   return data || [ ];
};
